// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSConfig.custom.products_per_page,
    /* Optional */
    paginationTypeAdvanced: true,
    activeLoadPreviousPage: true,
    loadProductFirst: false,
    breakpointMobile: "798",
    // paginationType: boostPFSConfig.custom.pagination_type.indexOf("load_more") != -1 ? "load_more" :
    // 				(boostPFSConfig.custom.pagination_type == 'infinite_scroll' ? 'infinite' : 'default'),
    filterTreeMobileStyle: "style1",
    startViewMore: { list: 11, box: 6, swatch: 7 },
  },
  selector: {
    trackingQuickView: ".quick_shop",
  },
};
// Declare Templates
var boostPFSTemplate = {
  // Grid Template
  productGridItemHtml:
    '<div class="{{itemDesktopWidthClass}} medium-down--one-half {{itemMobileWidthClass}} column {{itemQuickShopClass}} {{itemSwapImageClass}} {{itemHoverImage}} {{itemStickersClass}}' +
    " thumbnail product__thumbnail product__grid-item" +
    " thumbnail__hover-overlay--{{itemHoverClass}}" +
    ' has-padding-bottom">' + 
    '<div class="product-wrap">' +
    '<div class="product-image__wrapper">' +
    '<div class="image__container product__imageContainer">' +
    "<a href='{{itemUrl}}' tabindex='-1' aria-label='{{itemTitle}}'>" +
    "{{itemStickers}}" +
    "{{itemImages}}" +
    "{{itemHover}}" +
    "</a>" +
    "</div>" +
    "</div>" +
    '<div class="thumbnail__caption text-align-{{itemTextAlignClass}}">' +
    "{{itemProductInfo}}" +
    "</div>" +
    "</div>" +
    '<div class="plp_product_bottom ' +
    "{{soldOut}}" +
    '">' +
    "{{itemPriceInfo}}" +
    "{{itemSwatch}}" +
    "{{itemAddToCartInfo}}" +
    "</div>" +
    "</div>",

  itemHoverHtml:
    '<div class="thumbnail-overlay__container">' +
    '<a class="hidden-product-link" href="{{itemUrl}}">{{itemTitle}}</a>' +
    "{{itemProductInfoHover}}" +
    "{{itemQuickShop}}" +
    "{{itemReviewsHover}}" +
    "</div>",

  itemProductInfoHtml:
    '<div class="product-thumbnail">' +
    "{{itemVendor}}" +
    '<a href="{{itemUrl}}" class="product-thumbnail__title" aria-label="{{itemTitle}}">{{itemTitle}}</a>' +
    "{{itemComingSoon}}" +
    "</div>",

  itemPriceInfoHtml: '<div class="product-price">' + "{{itemPrice}}" + "</div>",

  // Pagination Template
  previousActiveHtml:
    '<a href="{{itemUrl}}" class="pagination-previous">' +
    boostPFSConfig.label.previous +
    "</a>",
  nextActiveHtml:
    '<a href="{{itemUrl}}" class="pagination-next">' +
    boostPFSConfig.label.next +
    "</a>",
  pageItemHtml:
    '<li><a class="pagination-link" href="{{itemUrl}}">{{itemTitle}}</a></li>',
  pageItemSelectedHtml:
    '<li><a class="pagination-link is-current">{{itemTitle}}</a></li>',
  pageItemRemainHtml: '<li><a class="pagination-ellipsis">…</a></li>',
  paginateHtml:
    '<nav class="pagination paginate--both" aria-label="pagination">{{previous}}<ul class="pagination-list">{{pageItems}}</ul>{{next}}</nav>',

  // Sorting Template
  sortingHtml:
    '<span class="custom-select-trigger" tabindex="0"><span class="custom-select-trigger-item"></span></span><div role="listbox" class="custom-options">{{sortingItems}}</div>',
};
(function () {
  BoostPFS.inject(this);

  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (
    data,
    index,
    totalProduct
  ) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    if (!totalProduct) totalProduct = this.totalProduct;
    if (totalProduct > 1) {
      jQ(".boost-pfs-filter-total-product").html(totalProduct + " Results");
    } else {
      jQ(".boost-pfs-filter-total-product").html(totalProduct + " Result");
    }
    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    // Add class
    var itemDesktopWidthClass = "one-third";
    switch (boostPFSConfig.custom.products_per_row) {
      case 1:
        itemDesktopWidthClass = "one-whole";
        break;
      case 2:
        itemDesktopWidthClass = "one-half";
        break;
      case 3:
        itemDesktopWidthClass = "one-third";
        break;
      case 4:
        itemDesktopWidthClass = "one-fourth";
        break;
      case 5:
        itemDesktopWidthClass = "one-fifth";
        break;
      case 6:
        itemDesktopWidthClass = "one-sixth";
        break;
      case 7:
        itemDesktopWidthClass = "one-seventh";
        break;
      case 8:
        itemDesktopWidthClass = "one-eighth";
        break;
    }
    itemHtml = itemHtml.replace(
      /{{itemDesktopWidthClass}}/g,
      itemDesktopWidthClass
    );
    itemHtml = itemHtml.replace(
      /{{itemMobileWidthClass}}/g,
      boostPFSConfig.custom.mobile_products_per_row == 1
        ? "small-down--one-whole"
        : "small-down--one-half"
    );
    itemHtml = itemHtml.replace(
      /{{itemQuickShopClass}}/g,
      boostPFSConfig.custom.enable_quickshop
        ? "quick-shop--true quick-shop--closed product-{{itemId}} js-product_section"
        : ""
    );
    itemHtml = itemHtml.replace(
      /{{itemStickersClass}}/g,
      boostPFSConfig.custom.stickers_enabled ? "has-thumbnail-sticker" : ""
    );
    itemHtml = itemHtml.replace(
      /{{itemHoverClass}}/g,
      boostPFSConfig.custom.thumbnail_hover_enabled.toString()
    );
    itemHtml = itemHtml.replace(
      /{{itemSwapImageClass}}/g,
      boostPFSConfig.custom.show_secondary_image && data.images_info.length > 1
        ? "swap--true"
        : ""
    );
    itemHtml = itemHtml.replace(
      /{{itemHoverImage}}/g,
      boostPFSConfig.custom.show_secondary_image && data.images_info.length > 1
        ? "has-secondary-image-swap"
        : ""
    );
    itemHtml = itemHtml.replace(
      /{{itemTextAlignClass}}/g,
      boostPFSConfig.custom.thumbnail_text_alignment
    );

    // Add stickers
    var itemStickers = buildStickers(data);
    itemHtml = itemHtml.replace(/{{itemStickers}}/g, itemStickers);

    // Add images
    var itemImages = buildImages(data);
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImages);

    // Add hover elements
    var itemHover = buildHover(data);
    itemHtml = itemHtml.replace(/{{itemHover}}/g, itemHover);

    // Add product info
    itemHtml = itemHtml.replace(
      /{{itemProductInfo}}/g,
      boostPFSTemplate.itemProductInfoHtml
    );

    // Add product price info
    itemHtml = itemHtml.replace(
      /{{itemPriceInfo}}/g,
      boostPFSTemplate.itemPriceInfoHtml
    );

    // Add vendor
    var itemVendor = boostPFSConfig.custom.display_vendor
      ? '<span class="product-thumbnail__vendor">{{itemVendor}}</span>'
      : "";
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendor);

    var collectionHandles = data.collections.map((x) => x.handle);
    var isComingSoon = collectionHandles.indexOf("coming-soon") != -1;
    // Add coming soon
    if (isComingSoon) {
      itemHtml = itemHtml.replace(
        /{{itemComingSoon}}/g,
        "<span>" + boostPFSConfig.label.coming_soon + "</span>"
      );
      itemHtml = itemHtml.replace(/{{itemPrice}}/g, "");
      itemHtml = itemHtml.replace(/{{soldOut}}/g, "");

      // Add price
    } else {
      itemHtml = itemHtml.replace(/{{itemComingSoon}}/g, "");
      itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
      if (!data.available) {
        itemHtml = itemHtml.replace(/{{soldOut}}/g, "sold_out");
      } else {
        itemHtml = itemHtml.replace(/{{soldOut}}/g, "");
      }
    }

    // Add swatch
    var soldOut = !data.available;
    var itemSwatch = buildSwatch(data);
    if (!soldOut) {
      if (itemSwatch) {
        function addStr(itemSwatch, index, stringToAdd){
          return itemSwatch.substring(0, index) + stringToAdd + itemSwatch.substring(index, itemSwatch.length);
        }
        let stringToAdd = ' aria-label="Select Option"';
        itemSwatch = addStr(itemSwatch, 2, stringToAdd);
        
        itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatch);
        itemHtml = itemHtml.replace(/{{itemAddToCartInfo}}/g, "");
      } else {
        // Add product add to cart info
        itemHtml = itemHtml.replace(/{{itemSwatch}}/g, "");
        itemAddToCart = buildAddToCart(data);
        itemHtml = itemHtml.replace(/{{itemAddToCartInfo}}/g, itemAddToCart);
      }
    } else {
      itemHtml = itemHtml.replace(/{{itemAddToCartInfo}}/g, "");
      itemHtml = itemHtml.replace(/{{itemSwatch}}/g, "");
    }

    // Add reviews
    var itemReviews =
      boostPFSConfig.custom.enable_shopify_collection_badges &&
      boostPFSConfig.custom.enable_shopify_review_comments
        ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>'
        : "";
    if (boostPFSConfig.custom.thumbnail_hover_enabled) {
      itemHtml = itemHtml.replace(/{{itemReviewsHover}}/g, itemReviews);
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, "");
    } else {
      itemHtml = itemHtml.replace(/{{itemReviewsHover}}/g, "");
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviews);
    }

    // Add quick shop button placeholder
    var itemQuickShop = boostPFSConfig.custom.enable_quickshop
      ? '<div data-boost-pfs-quickshop-id="{{itemId}}" style="display: none"></div>'
      : "";
    itemHtml = itemHtml.replace(/{{itemQuickShop}}/g, itemQuickShop);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrl(data)
    );

    if (
      boostPFSThemeConfig.boost_maketing_1 === "none" &&
      boostPFSThemeConfig.boost_maketing_2 !== "none"
    ) {
      if (index == 14) {
        itemHtml +=
          '<div class="one-fourth medium-down--one-half small-down--one-half column product__grid-item block-maketing-2">' +
          htmlDecode(boostPFSThemeConfig.boost_maketing_2) +
          "</div>";
      }
    } else {
      if (index == 3 && boostPFSThemeConfig.boost_maketing_1 !== "none") {
        itemHtml +=
          '<div class="one-fourth medium-down--one-half small-down--one-half column product__grid-item block-maketing-1">' +
          htmlDecode(boostPFSThemeConfig.boost_maketing_1) +
          "</div>";
      }

      if (index == 13 && boostPFSThemeConfig.boost_maketing_2 !== "none") {
        itemHtml +=
          '<div class="one-fourth medium-down--one-half small-down--one-half column product__grid-item block-maketing-2">' +
          htmlDecode(boostPFSThemeConfig.boost_maketing_2) +
          "</div>";
      }
    }

    return itemHtml;
  };

  function buildStickers(data) {
    var html = "";
    var stickers = [];
    if (boostPFSConfig.custom.stickers_enabled) {
     
      var collections = data.collections.map((x) => x.handle);
      var stickerCollections = [
        "best-seller",
        "coming-soon",
        "new",
        "pre-order",
        "staff-pick",
        "trending",
        "test-soon"
      ];
      var stickerClass = boostPFSConfig.custom.sticker_class;
      for (var i = 0; i < stickerCollections.length; i++) {
        var stickerCollection = stickerCollections[i];
        if (collections.indexOf(stickerCollection) != -1) {
          var stickerText =
            boostPFSConfig.label[stickerCollection.replace("-", "_")];
          var sticker =
            '<div class="' +
            stickerCollection +
            "-sticker thumbnail-sticker sticker-" +
            i +
            " " +
            stickerClass +
            '"><span class="sticker-text">' +
            stickerText +
            "</span></div>";
          stickers.push(sticker);
        }
      }

      var tags = data.tags;
      for (const tag of tags) {
        //console.log({{ 'collections.general.new' | t }},'testing var');
        if(tag.includes('arriving') ){
          const date = tag.slice(-5);
          console.log(date,'date');
          var arriveSticker =
            `<div class="arriving-sticker generic thumbnail-sticker sticker-${i}">` + `<span class="sticker-text">Arriving ${date}!</span></div>`;
          stickers.push(arriveSticker);
        }
      }

      var onSale = data.available && data.price_min < data.compare_at_price_max;
      if (onSale) {
        var sticker =
          '<div class="sale-sticker ' +
          " " +
          stickerClass +
          ' thumbnail-sticker"><span class="sticker-text">' +
          boostPFSConfig.label.sale +
          "</span></div>";
        stickers.push(sticker);
      }

      if (stickers.length > 0) {
        html =
          '<div class="sticker-holder sticker-shape-' +
          boostPFSConfig.custom.sticker_shape +
          " sticker-position-" +
          boostPFSConfig.custom.sticker_position +
          '">' +
          '<div class="sticker-holder__content sticker-holder__content--">' +
          stickers.join("") +
          "</div>" +
          "</div>";
      }
    }
    return html;
  }

  function buildImages(data) {
    var html = "";
    var images = data.images_info;
    if (!images || images.length == 0) {
      images.push({
        src: boostPFSAppConfig.general.no_image_url,
        width: 480,
        height: 480,
      });
    }

    html += buildImageElement(images[0]);

    if (boostPFSConfig.custom.show_secondary_image && images.length > 1) {
      html += buildImageElement(
        images[1],
        "lazypreload secondary swap--visible"
      );
    }

    return html;
  }

  function buildImageElement(image, additionalClass) {
    var additionalClass =
      typeof additionalClass !== "undefined" ? additionalClass : "";
    var html = "";
    var heightStyle = "";
    var widthStyle = "";
    var aspectRatio = image.width / image.height;
    if (boostPFSConfig.custom.align_height) {
      heightStyle +=
        "max-height: " + boostPFSConfig.custom.collection_height + "px;";
      widthStyle +=
        "width: " +
        aspectRatio * boostPFSConfig.custom.collection_height +
        "px; max-width: " +
        image.width +
        "px;";
    }

    var backgroundColor =
      boostPFSConfig.custom.image_loading_style == "color"
        ? "background: url(" + Utils.optimizeImage(image.src, "1x") + "); "
        : "";
    var lowQualityImage =
      boostPFSConfig.custom.image_loading_style == "blur-up"
        ? Utils.optimizeImage(image.src, "50x")
        : "";

    html +=
      '<div class="image-element__wrap" style="' +
      backgroundColor +
      heightStyle +
      widthStyle +
      '">' +
      '<img alt=""' +
      ' class="lazyload transition--' +
      boostPFSConfig.custom.image_loading_style +
      " " +
      additionalClass +
      '"' +
      (lowQualityImage && lowQualityImage !== ""
        ? ' src="' + lowQualityImage + '"'
        : "") +
      ' data-src="' +
      Utils.optimizeImage(image.src, "1600x") +
      '"' +
      ' data-sizes="auto"' +
      ' data-aspectratio="' +
      aspectRatio +
      '"' +
      ' data-srcset="' +
      bgset(image) +
      '"' +
      ' srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="' +
      ' height="' +
      image.height +
      '"' +
      ' width="' +
      image.width +
      '"' +
      ' style="' +
      heightStyle +
      '"' +
      "/>" +
      "</div>";
    return html;
  }

  function buildHover(data) {
    var html = "";
    if (
      boostPFSConfig.custom.enable_quickshop ||
      boostPFSConfig.custom.thumbnail_hover_enabled
    ) {
      html = boostPFSTemplate.itemHoverHtml;
      if (boostPFSConfig.custom.thumbnail_hover_enabled) {
        var itemProductInfoHover =
          '<div class="quick-shop__info">' +
          '<div class="thumbnail-overlay">' +
          '<div class="info text-align-center">' +
          "{{itemProductInfo}}" +
          "</div>" +
          "</div>" +
          "</div>";
        html = html.replace(/{{itemProductInfoHover}}/g, itemProductInfoHover);
      } else {
        html = html.replace(/{{itemProductInfoHover}}/g, "");
        html = html.replace(/{{itemReviews}}/g, "");
      }
      if (!boostPFSConfig.custom.enable_quickshop) {
        html = html.replace(/{{itemQuickShop}}/g, "");
      }
    }
    return html;
  }

  function isPreorder(data) {
    return (data.tags || []).some(function (t) {
      return String(t).toLowerCase() === "preorderplp";
    });
  }

  function buildAddToCart(data) {
    var html = "";
    //var url = Utils.buildProductItemUrl(data)+ '?view=boost-pfs-quickview';
    var url = "/cart/add.js";
    var variant_id = data.variants[0].id;
    var var_price = parseFloat(data.price_min);

    // Preorder products keep the normal ADD TO BAG button, but clicking it
    // opens the product page instead of adding to the cart.
    var preorder = isPreorder(data);
    var btnClass = preorder
      ? "button action_button button--add-to-cart"
      : "button ajax-submit action_button button--add-to-cart";
    var btnAction = preorder
      ? ' data-preorder-href="' +
        Utils.buildProductItemUrl(data) +
        '" onclick="window.location.href=this.getAttribute(\'data-preorder-href\');return false;"'
      : " data-add-to-cart-trigger";

    html += '<form method="post" action="' + url + '" id="product_form_'+data.id+'">';
    html +=
      '<input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">';
    html +=
      '<input type="hidden" name="id" value="' +
      variant_id +
      '"><input type="hidden" name="quantity" value="1">';
    html +=
      '<button type="button" aria-label="'+data.title+' Add to Bag" name="add" pro_title="'+data.title+'" var_title="'+data.variants[0].title+'" pro_price="'+var_price+'" var_sku="'+data.variants[0].sku+'" pro_brand="'+data.vendor+'" pro_category="'+data.product_type+'" class="' + btnClass + '" data-label="ADD TO BAG"' + btnAction + '>';
    html += ' <span class="text">ADD TO BAG</span>';
    html +=
      ' <svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" class="checkmark">';
    html +=
      ' <path fill="#000" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"></path></svg>';
    html += "</button> ";
    html += "<script> ";
    //html +=' $(document).on("click", ".ajax-submit", function (e) {e.preventDefault(); const $addToCartForm = $(this).closest("form"); Shopify.theme.jsAjaxCart.addToCart($addToCartForm);}) ';
    html += "</script> ";
    html += "</form> ";

    return html;
  }

  function buildPrice(data) {
    var html = "";
    var onSale = data.compare_at_price_max > data.price_min;
    var soldOut = !data.available;
    var priceVaries = data.price_max != data.price_min;
    html +=
      '<span class="product-thumbnail__price price ' +
      (onSale ? "sale" : "") +
      (priceVaries && data.price_min > 0 ? "priceVaries" : "") +
      '"> <span>';
    if (!soldOut) {
      if (data.price_min > 0) {
        if (priceVaries) {
          html +=
            "<span><small><em>" + boostPFSConfig.label.from + "</em></small> ";
        }
        html +=
          '<span aria-hidden="true" class="money">' +
          Utils.formatMoney(data.price_min) +
          "</span>" +
          '<span class="visuallyhidden">' +
          Utils.formatMoney(data.price_min) +
          " is sale price</span> </span>";
      } else {
        html += boostPFSConfig.custom.free_price_text;
      }
      if (onSale) {
        html +=
          '<span class="product-thumbnail__was-price was-price">' +
          '<span aria-hidden="true" class="money">' +
          Utils.formatMoney(data.compare_at_price_max) +
          "</span>" + '<span class="visuallyhidden">' +
          Utils.formatMoney(data.compare_at_price_max) +
          " is actual price</span>" +
          "</span></span>";
      }
      html += '<div class="plp_divider">|</div>';
    } else {
      html +=
        '<span class="product-thumbnail__sold-out sold-out">' +
        boostPFSConfig.label.sold_out +
        "</span>";
    }

    return html;
  }

  function buildSwatch(data) {
    var html = "";
    var values = [];
    var swatchItems = [];
    var colorFlag = 0;
    var sizeFlag = 0;
    if (boostPFSConfig.custom.collection_swatches) {
      data.variants.forEach(function (variant) {
        var colorValue = "";
        var optionValue = "";
        variant.merged_options.forEach(function (option) {
          var key = option.split(":")[0];
          var value = option.split(":")[1];
          if (
            (key.toLowerCase().indexOf("color") != -1 ||
              key.toLowerCase().indexOf("colour") != -1) &&
            values.indexOf(value.toLowerCase()) == -1
          ) {
            values.push(value.toLowerCase());
            colorValue = value;
            optionValue = key;
            colorFlag += 1;
          }
          if (
            key.toLowerCase().indexOf("size") != -1 &&
            values.indexOf(value.toLowerCase()) == -1
          ) {
            sizeFlag += 1;
          }
        });
        if (colorValue) {
          var swatchItem =
            '<a href="{{variantUrl}}" class="swatch swatch__style--{{swatchShape}}" data-swatch-name="meta-{{slugifyOptionValue}}_{{slugifyColorValue}}">' +
            '<span data-image="{{variantImage}}" style="background-color: {{colorBackground}};">' +
            '<img class="swatch__image" src="{{colorImage}}" onerror="this.className += \' swatch__image--empty\'">' +
            "</span>" +
            "</a>";

          swatchItem = swatchItem.replace(
            /{{swatchShape}}/g,
            boostPFSConfig.custom.collection_swatches_shape
          );
          swatchItem = swatchItem.replace(
            /{{colorBackground}}/g,
            Utils.slugify(colorValue).split("-").pop()
          );
          swatchItem = swatchItem.replace(
            /{{slugifyOptionValue}}/g,
            Utils.slugify(optionValue).replace("-", "_")
          );
          swatchItem = swatchItem.replace(
            /{{slugifyColorValue}}/g,
            Utils.slugify(colorValue).replace("-", "_")
          );
          swatchItem = swatchItem.replace(
            /{{variantUrl}}/g,
            Utils.buildProductItemUrl(data) + "?variant=" + variant.id
          );

          var colorImage =
            boostPFSAppConfig.general.file_url.split("?")[0] +
            Utils.slugify(colorValue) +
            "_50x.png";
          swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);

          var variantImage = "";
          var noImageClass = "";
          if (variant.image) {
            switch (boostPFSConfig.custom.products_per_row) {
              case 2:
                variantImage = Utils.optimizeImage(variant.image, "600x");
                break;
              case 3:
                variantImage = Utils.optimizeImage(variant.image, "500x");
                break;
              default:
                variantImage = Utils.optimizeImage(variant.image, "400x");
                break;
            }
          }
          swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
          swatchItems.push(swatchItem);
        }
      });
    }
    if ((swatchItems.length > 0 && colorFlag > 1 && sizeFlag > 1) || swatchItems.length > 0 && colorFlag == 1 && sizeFlag > 1 || swatchItems.length > 0 && colorFlag > 1 && sizeFlag == 1) {
      html = '<a href="{{itemUrl}}" class="more_color">SELECT OPTIONS</a>';
    } else if (swatchItems.length > 0 && colorFlag > 1) {
      html = '<a href="{{itemUrl}}" class="more_color">SELECT COLOR</a>';
    } else if (sizeFlag > 1) {
      html = '<a href="{{itemUrl}}" class="more_color">SELECT SIZE</a>';
    }
    return html;
  }

  function bgset(image) {
    var bgset = "";
    if (image) {
      var aspect_ratio = image.width / image.height;

      if (image.width > 180)
        bgset +=
          " " +
          Utils.optimizeImage(image.src, "180x") +
          " 180w " +
          Math.round(180 / aspect_ratio) +
          "h,";
      if (image.width > 360)
        bgset +=
          " " +
          Utils.optimizeImage(image.src, "360x") +
          " 360w " +
          Math.round(360 / aspect_ratio) +
          "h,";
      bgset += " " + image.src + " " + image.width + "w " + image.height + "h,";
    }
    return bgset;
  }

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;

    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (
      Settings.getSettingValue("general.paginationType") == "default" &&
      totalPage > 1
    ) {
      var paginationHtml = boostPFSTemplate.paginateHtml;
      // Build Previous
      var previousHtml =
        currentPage > 1 ? boostPFSTemplate.previousActiveHtml : "";
      previousHtml = previousHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage - 1)
      );
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
      // Build Next
      var nextHtml =
        currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : "";
      nextHtml = nextHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage + 1)
      );
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
      // Create page items array
      var beforeCurrentPageArr = [];
      for (
        var iBefore = currentPage - 1;
        iBefore > currentPage - 3 && iBefore > 0;
        iBefore--
      ) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift("...");
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);
      var afterCurrentPageArr = [];
      for (
        var iAfter = currentPage + 1;
        iAfter < currentPage + 3 && iAfter <= totalPage;
        iAfter++
      ) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push("...");
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }
      // Build page items
      var pageItemsHtml = "";
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == "...") {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml +=
            pageArr[iPage] == currentPage
              ? boostPFSTemplate.pageItemSelectedHtml
              : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(
          /{{itemUrl}}/g,
          Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
        );
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }

    return "";
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = "";
        var sortingArray = [];

        for (var key in sortingArr) {
          sortingArray.push({ key: key, value: sortingArr[key] });
        }

        console.log(sortingArray.length); 
        let ls = sortingArray.length -1;
        for (var k in sortingArray) {
          let kk = "";
          if(k==0){ kk = "first-focusable-cart"}
          else if(k==ls){ kk = "last-focusable-cart"};
          sortingItemsHtml += 
            '<span role="option" class="custom-option '+
            kk
            +'" tabindex="0" aria-label="' +
            sortingArray[k].value +
            '" data-value="' +
            sortingArray[k].key +
            '">' +
            sortingArray[k].value +
            "</span>";
        }
        var html = boostPFSTemplate.sortingHtml.replace(
          /{{sortingItems}}/g,
          sortingItemsHtml
        );
        return html;
      }
    }
    return "";
  };

  ProductSorting.prototype.bindEvents = function () {
    jQ(document).on("click", ".custom-option", function () {
      var selectedSort = jQ(this).data("value");
      FilterApi.setParam("sort", selectedSort);
      FilterApi.setParam("page", 1);
      FilterApi.applyFilter("sort");
    });
  };

  ProductSorting.prototype.afterRender = function () {
    var current_sort = "sorting_" + Globals.queryParams.sort.replace("-", "_");
    var slabel = boostPFSThemeConfig.label[current_sort];
    if (window.location.search.includes("sort=")) {
      jQ(".custom-select-trigger-item").html(slabel);
      jQ(".custom-select-trigger").attr('aria-label','Sort By');
    }
    jQ(".custom-select-trigger-item").html(slabel);
    jQ(".custom-select-trigger").attr('aria-label','Sort By');
    jQ(".custom-select-trigger").attr('role','Combobox');
    jQ(".custom-select-trigger").attr('aria-expanded','false');
    jQ(".boost-pfs-filter-top-sorting").removeClass(
      "sort_by custom-select opened"
    );
  };

  function htmlDecode(data) {
    var ret = data.replace(/&gt;/g, ">");
    ret = ret.replace(/&lt;/g, "<");
    ret = ret.replace(/&quot;/g, '"');
    ret = ret.replace(/&apos;/g, "'");
    ret = ret.replace(/&amp;/g, "&");
    return ret;
  }

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data, eventType) {
    buildTheme();
  };

  // Build additional elements
  FilterResult.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;

    if (window.location.search.includes("pf_")) {
      jQ(".boost-pfs-filter-btn-clear-all").show();
    }

    // Remove sorting if don't have any items
    if (data.total_product <= 0) {
      jQ(".boost-pfs-filter-top-sorting").hide();
      jQ(".boost-pfs-filter-sidebar").remove();
      jQ(".boost-pfs-filter-skeleton-text").hide();
    }
  };
  jQ(document).on("click", ".custom-select-trigger", function () {
    jQ(".boost-pfs-filter-top-sorting").toggleClass(
      "sort_by custom-select opened"
    );
    let trigg = jQ(".custom-select-trigger").attr('aria-expanded');
    if(trigg == 'true'){
      jQ(".custom-select-trigger").attr('aria-expanded','false');
    }
    else{
      jQ(".custom-select-trigger").attr('aria-expanded','true');
    }
  });
  function buildTheme() {
    if (window.SPR) {
      SPR.initDomEls();
      SPR.loadBadges();
    }
    Shopify.PaymentButton.init();

    if (boostPFSConfig.custom.show_multiple_currencies) {
      convertCurrencies();
    }
  }

  //code for load more in PLP
  jQuery(document).delegate("#customclearall", "click", function () {
    jQuery(".boost-pfs-filter-clear-all").trigger("click");
  });

  FilterOptionItemList.prototype.getTemplate = function () {
    if (this.parent.filterOptionId == "pf_t_character") {
      return `
              <li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">
                  <button class="{{class.button}}">
                      <span class="boost-pfs-check-box"></span>
                      <span class="boost-pfs-filter-option-value">{{label}}</span>
                      <span class="boost-pfs-filter-option-amount">{{countLabel}}</span>
                  </button>
               </li>
               `;
    } else {
      return `
              <li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">
                  <button class="{{class.button}}">
                      <span class="boost-pfs-check-box"></span>
                      <span class="boost-pfs-filter-option-value">{{label}}</span>
                      <span class="boost-pfs-filter-option-amount">{{countLabel}}</span>
                  </button>
              </li>
          `;
    }
  };
  FilterOptionItem.prototype.buildLabel = function () {
    var array = boostPFSThemeConfig.character_filter_images.split(", ");

    for (var i = 0; i < array.length; i++) {
      array[i] = array[i].split(":-");
    }

    var filterOption = this.filterOption ? this.filterOption : this.parent;

    var label = this.label;
    var src;

    if (label.indexOf("Character:") != -1) {
      var labelOringinalvalue = label;
      labelOringinalvalue = labelOringinalvalue.replace("Character:", "");

      for (var i = 0; i < array.length; i++) {
        if (array[i][0] == labelOringinalvalue) {
          src = array[i][1];
          label =
            label +
            '<span class="character_icon"><img src = "' +
            src +
            '" alt="'+ label+'"></span>';
        }
      }
    }
    var prefix = filterOption.prefix;

    if (typeof label != "string") return "";

    // Remove Prefix
    if (typeof prefix == "string") {
      prefix = prefix.replace(/\\/g, "");
      label = label.replace(prefix, "").trim();
    }

    // Escape special character
    label = Utils.stripScriptTag(label);

    // No capital label of Rating filter option
    if (typeof label !== "undefined") {
      if (label.indexOf("boost-pfs-filter-icon-star") > -1) return label;

      // Make the text to uppercase
      filterOption.displayAllValuesInUppercaseForm =
        filterOption.displayAllValuesInUppercaseForm || false;
      if (filterOption.displayAllValuesInUppercaseForm)
        return label.toUpperCase();

      // Make all letters lowercase first, then capitalize all first letters of each string in a filter option value
      // For example: HELLO World => Hello World
      if (Settings.getSettingValue("general.forceCapitalizeFilterOptionValues"))
        return Utils.capitalize(label, true);

      // Make all letters lowercase first, then capitalize first letter of a filter option value
      // For example: product fILTER => Product filter
      if (
        Settings.getSettingValue(
          "general.capitalizeFirstLetterFilterOptionValues"
        )
      )
        return Utils.capitalize(label, true, true);

      // Just capitalize first letter and don't change the format of any other letters
      // For example: hello wORLD => Hello WORLD
      if (Settings.getSettingValue("general.capitalizeFilterOptionValues"))
        return Utils.capitalize(label);
    }
    // return label
    return label;
  };
  FilterTree.prototype.getFooterTemplate = function () {
    return '<div class="boost-pfs-filter-mobile-footer"><button class="{{class.showResultFilterButton}}" type="button">{{label.showResult}}</button><button class="boost-pfs-filter-btn-clear-all" type="button">Clear all</button></div>';
  };

  FilterTree.prototype.afterRender = function () {
    jQ(document).on("click", ".boost-pfs-filter-btn-clear-all", function () {
      jQ("button.boost-pfs-filter-clear-all").trigger("click");
    });
  };

  FilterClearButton.prototype.onClearAll = function () {
    var currentFilterOptionIds = [];
    Object.keys(Globals.queryParams).forEach((queryParam) => {
      if (queryParam.startsWith(Globals.prefix)) {
        currentFilterOptionIds.push(queryParam);
      }
    });

    if (currentFilterOptionIds.length == 0) return;

    currentFilterOptionIds.forEach((filterOptionId) => {
      FilterApi.setParam(filterOptionId, null);
    });

    var eventType = "clearAll";
    var eventInfo = {};
    FilterApi.applyFilter(eventType, eventInfo);
  };
})();
